module.exports = __webpack_public_path__ + "media/images/mission_icon_1-95c8e8c653c2db626b727cf8fcdee4f2.svg";